import React from 'react';
import styles from './PortfolioValueCard.module.css';

const PortfolioValueCard = ({ portfolio }) => {
  if (!portfolio || !portfolio.totalPortfolio) {
    return null;
  }

  const { investment: stockInvestment, value: stockValue, change: stockChange } = portfolio.totalPortfolio;
  
  // Logic as per your file: 
  // Portfolio Value = stockValue
  // Total PnL = stockValue - stockInvestment
  // Percentage = based on investment
  const totalValue = stockValue;
  const totalPnL = stockValue - stockInvestment;
  const totalInvestment = stockInvestment; 
  const pnlPercentage = totalInvestment > 0 ? (totalPnL / totalInvestment) * 100 : 0;

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', { 
        style: 'currency', 
        currency: 'INR',
        maximumFractionDigits: 0 
    }).format(amount);
  };

  return (
    <div className={styles.portfolioContainer}>
      <div className={styles.portfolioValueCard}>
        <div className={styles.header}>
          <h2>Portfolio</h2>
          <p>Real-time holdings and performance.</p>
        </div>
        <div className={styles.mainValue}>
          <span className={styles.value}>{formatCurrency(totalValue)}</span>
          <span className={`${styles.change} ${totalPnL >= 0 ? styles.positive : styles.negative}`}>
            {totalPnL >= 0 ? '+' : ''}{formatCurrency(totalPnL)} ({pnlPercentage.toFixed(2)}%)
          </span>
        </div>
        <div className={styles.footer}>
          <div className={styles.footerItem}>
            <span className={styles.label}>Investment</span>
            <span className={styles.footerValue}>{formatCurrency(totalInvestment)}</span>
          </div>
          <div className={styles.footerItem} style={{ textAlign: 'right' }}>
            <span className={styles.label}>Today's Stock Change</span>
            <span className={`${styles.footerValue} ${stockChange >= 0 ? styles.positive : styles.negative}`}>
              {stockChange >= 0 ? '↑' : '↓'} {formatCurrency(Math.abs(stockChange))}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioValueCard;
